<template>
  <div>
    <a class="text-danger" :href="getAnchorVal()">{{ showErrors() }}</a>
  </div>
</template>

<script>
export default {
  name: "BulkTypeCard",
  props: {
    msg: String,
    type: String,
    pickup: String,
    id: String
  },
  methods: {
    showErrors() {
      var missVars = []
      if(this.msg == "" || this.msg == null) {
          missVars.push('Message')
      }

      if(this.pickup == "" || this.pickup == null) {
          missVars.push('Pickup')
      }
      if(missVars.length > 0)
          return "Missing data for the following fields: '" + missVars.join(",") + "'"
      else
        return ""
    },
    getAnchorVal() {
      return '#' + this.id
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>